import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Auth({ allowedRoles, children }) {
  const navigate = useNavigate();

  // Get user from Redux
  const user = useSelector((state) => state.auth.user);
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }

    if (user && allowedRoles && !allowedRoles.includes(user.role)) {
      navigate("/unauthorized");
    }
  }, [user, allowedRoles, navigate]);

  // Show nothing while checking auth
  if (!user) return null;

  // Render children if user is authorized
  return allowedRoles.includes(user.role) ? children : null;
}
